import { Reducer, ReducersMapObject, combineReducers } from "@reduxjs/toolkit";
import { AuthState } from "../types/AuthType";
import { loginReducer } from "./loginSlice";

export const authReducerMap: ReducersMapObject<AuthState> = {
  login: loginReducer,
};
export const authReducer: Reducer<AuthState> =
  combineReducers<AuthState>(authReducerMap);
